
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import SolidButton from '@devsisters/ui-careers/lib/SolidButton';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"solidbutton"}}>{`SolidButton`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { SolidButton } from '@devsisters/ui/careers';
// 또는 import SolidButton from '@devsisters/ui-careers/lib/SolidButton';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h2>색상</h2>\n<div style={{ display: \'flex\' }}>\n  <SolidButton\n    type=\"primary\"\n    style={{\n      fontSize: \'22px\',\n      marginRight: \'10px\',\n    }}\n  >\n    primary\n  </SolidButton>\n  <SolidButton\n    type=\"dark\"\n    style={{\n      fontSize: \'22px\',\n      marginRight: \'10px\',\n    }}\n  >\n    dark\n  </SolidButton>\n  <SolidButton\n    type=\"light\"\n    style={{\n      fontSize: \'22px\',\n      marginRight: \'10px\',\n    }}\n  >\n    light\n  </SolidButton>\n</div>\n<h2>비활성화</h2>\n<SolidButton disabled style={{ fontSize: \'22px\' }}>\n  버튼 내용\n</SolidButton>\n<h2>가변폭</h2>\n<SolidButton style={{ fontSize: \'22px\' }}>버튼 내용</SolidButton>\n<h2>고정폭</h2>\n<SolidButton noPadding style={{ width: \'100px\', fontSize: \'22px\' }}>\n  버튼 내용\n</SolidButton>\n<h2>로딩</h2>\n<SolidButton waiting noPadding style={{ width: \'100px\', fontSize: \'22px\' }}>\n  버튼 내용\n</SolidButton>\n<h2>링크</h2>\n<SolidButton\n  style={{ fontSize: \'22px\' }}\n  link={[\n    \'#link1\',\n    function({ to, className, style, children }) {\n      return (\n        <a href={to} className={className} style={style}>\n          {children}\n        </a>\n      )\n    },\n  ]}\n>\n  버튼 내용\n</SolidButton>'} __scope={{props: this ? this.props : props,SolidButton}}>
  <h2>색상</h2>
  <div style={{ display: 'flex' }}>
    <SolidButton type='primary' style={{
      fontSize: '22px',
      marginRight: '10px'
    }}>primary</SolidButton>
    <SolidButton type='dark' style={{
      fontSize: '22px',
      marginRight: '10px'
    }}>dark</SolidButton>
    <SolidButton type='light' style={{
      fontSize: '22px',
      marginRight: '10px'
    }}>light</SolidButton>
  </div>
  <h2>비활성화</h2>
  <SolidButton disabled style={{ fontSize: '22px' }}>
    버튼 내용
  </SolidButton>
  <h2>가변폭</h2>
  <SolidButton style={{ fontSize: '22px' }}>
    버튼 내용
  </SolidButton>
  <h2>고정폭</h2>
  <SolidButton noPadding style={{ width: '100px', fontSize: '22px' }}>
    버튼 내용
  </SolidButton>
  <h2>로딩</h2>
  <SolidButton waiting noPadding style={{ width: '100px', fontSize: '22px' }}>
    버튼 내용
  </SolidButton>
  <h2>링크</h2>
  <SolidButton
    style={{ fontSize: '22px' }}
    link={[
      '#link1',
      function ({ to, className, style, children }) {
        return <a href={to} className={className} style={style}>{children}</a>;
      }
    ]}>
    버튼 내용
  </SolidButton>
</Playground>
           </MDXTag>
  }
}
  